import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "paragraph-text",
  "use": "paragraph-text-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"paragraph-text\"><path fill-rule=\"evenodd\" d=\"M4 17v2h10v-2H4Zm0-8v2h16V9H4Zm16 6v-2H4v2h16ZM4 7h16V5H4v2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol